<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="EditValidationTask">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Status <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="statusOptions" :object="true" :searchable="true" multiple="false"
                                track-by="value" label="label" v-model="formData.status"
                                placeholder="selectionnez le status" />
                            <ErrorMessage name="status" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Priority <span class="text-danger">*</span>
                            </label>
                            <Multiselect :options="priorityOptions" :searchable="true" multiple="false" track-by="value"
                                :object="true" label="label" v-model="formData.priority"
                                placeholder="selectionnez la priorité" />
                            <ErrorMessage name="priority" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure pour le traitement de la tâche (SLA)<span class="text-danger">*</span>
                            </label>
                            <Field name="sla_due_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.sla_due_at" />
                            <ErrorMessage name="sla_due_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure du traitement de la tâche par l'agent<span class="text-danger">*</span>
                            </label>
                            <Field name="started_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.started_at" />
                            <ErrorMessage name="started_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure de clôture de la tâche<span class="text-danger">*</span>
                            </label>
                            <Field name="completed_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.completed_at" />
                            <ErrorMessage name="completed_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure de correction de la tache<span class="text-danger">*</span>
                            </label>
                            <Field name="returned_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.returned_at" />
                            <ErrorMessage name="returned_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure de la dernière action significative sur la tâche<span
                                    class="text-danger">*</span>
                            </label>
                            <Field name="last_action_at" type="date"
                                class="form-control shadow-none fs-md-15 text-black" placeholder=""
                                v-model="formData.last_action_at" />
                            <ErrorMessage name="last_action_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date et heure d’expiration d’un verrou éventuel de la tâche<span
                                    class="text-danger">*</span>
                            </label>
                            <Field name="lock_expires_at" type="date"
                                class="form-control shadow-none fs-md-15 text-black" placeholder=""
                                v-model="formData.lock_expires_at" />
                            <ErrorMessage name="lock_expires_at" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                ValidationQueue <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="validationqueueOptions" :object="true" :searchable="true"
                                multiple="false" track-by="label" label="label"
                                placeholder="Sélectionner la validation Queue" v-model="formData.validationqueue" />

                            <ErrorMessage name="validationqueue" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Utilisateur <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="userOptions" :object="true" :searchable="true" multiple="false"
                                track-by="label" label="label" v-model="formData.user"
                                placeholder="Sélectionner l'utilisateur " />

                            <ErrorMessage name="user" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Référence vers le dossier BESC <span class="text-danger">*</span>
                            </label>

                            <Multiselect :options="bescOptions" :object="true" :searchable="true" multiple="false"
                                track-by="label" label="label" v-model="formData.besc"
                                placeholder="Sélectionner le besc concerné " />

                            <ErrorMessage name="besc" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Valider
                            </button>
                            <router-link to="/listevalidationtasks"
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                                    class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>


<script lang="ts">
import { defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { TypeFretPaiement } from '@/models/TypeFretPaiement';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { ValidationQueues, ValidationTask } from '@/models/ValidationTask';
import { ValidationCheck } from '@/models/ValidationCheck';
import JwtService from '@/services/JwtService';
import router from '@/router';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
    name: "EditValidationTask",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect

    },
    props: {
        item: {
            type: Number,
            default: 0,
        }
    },
    setup(props, { emit }) {
        const EditTaskSchema = Yup.object().shape({
            // status: Yup.string().required('Le status est obligatoire'),
            // priority: Yup.string().required('Le champ priority est obligatoire'),
            // sla_due_at: Yup.string().required('Ce champ est obligatoire'),
            // started_at: Yup.string().required('Ce champ est obligatoire'),
            // completed_at: Yup.string().required('Ce champ est obligatoire'),
            // returned_at: Yup.string().required('Ce champ est obligatoire'),
            // last_action_at: Yup.string().required('Ce champ est obligatoire'),
            // lock_expires_at: Yup.string().required('Ce champ est obligatoire'),
            // validationqueue: Yup.string().required('Ce champ est obligatoire'),
            // user: Yup.string().required('Ce champ est obligatoire'),
            // besc: Yup.string().required('Ce champ est obligatoire'),

        });
        const validationqueueOptions = ref([])
        const userOptions = ref([])
        const bescOptions = ref([])
        const router = useRouter();
        const route = useRoute();
        const taskId = route.params.id;
        const statusOptions = [
            { value: 'PENDING', label: 'En Attente' },
            { value: 'IN_PROGRESS', label: 'En Cours' },
            { value: 'COMPLETED', label: 'Terminé' },
            { value: 'RETURNED_FOR_CORRECTION', label: 'Retour Pour Correction' },
            { value: 'CANCELLED', label: 'Supprimé' },
        ]


        const priorityOptions = [
            { value: 'LOW', label: 'Faible' },
            { value: 'NORMAL', label: 'Normale' },
            { value: 'HIGH', label: 'Élevée' },
            { value: 'CRITICAL', label: 'Critique' },
        ]

        const fetchValidationQueue = async () => {
            try {
                const user = JwtService.getUser();
                console.log("user:", user);
                if (!user) return error("Utilisateur non connecté");
                const userId = user.userId.replace(/\/+$/, '').trim();
                if (!userId) return error("Utilisateur non connecté");
                const response = await ApiService.get(`/validationqs?limit=0&userCreationId=${userId}`);
                const validationQueueData = response.data.data.data;
                validationqueueOptions.value = validationQueueData.map((validationqueue) => ({
                    value: validationqueue.id,
                    label: `${validationqueue.name}`
                }))
            } catch (error) {

                //
            }
        }

        // const fetchUser = async () => {
        //     try {
        //         const response = await ApiService.get('/users?limit=0');
        //         const userData = response.data.data.data;
        //         userOptions.value = userData.map((user) => ({
        //             value: user.id,
        //             label: `${user.nom} ${user.prenom}`
        //         }))
        //     } catch (error) {
        //         //
        //     }
        // }

        const getUsers = async () => {
            const user = JwtService.getUser();
            if (!user) return error("Utilisateur non connecté");

            try {
                const data = await ApiService.get('/users?limit=0');
                userOptions.value = data.data.data.data
                    .filter((u: any) => u.id !== user.userId)
                    .map((u: any) => ({
                        label: `${u.nom} ${u.prenom}`,
                        value: u.id,
                    }));
            } catch (err: any) {
                error(err?.response?.data?.message || 'Erreur lors de la récupération des utilisateurs');
            }
        };

        const fetchBesc = async () => {
            try {
                const response = await ApiService.get('/bescs?limit=0');
                const bescData = response.data.data.data;
                bescOptions.value = bescData.map((besc) => ({
                    value: besc.id,
                    label: `${besc.refbesc}`
                }))
            } catch (error) {
                //
            }
        }

        // Détection des champs date
        const isDateField = (key: string) => {
            return [
                "sla_due_at",
                "started_at",
                "completed_at",
                "returned_at",
                "last_action_at",
                "lock_expires_at",
            ].includes(key);
        };

        const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dateString.split("T")[0];
        };
        interface FormDataType {
            status: { value: string; label: string } | null;
            priority: { value: string; label: string } | null;
            sla_due_at: string;
            started_at: string;
            completed_at: string;
            returned_at: string;
            last_action_at: string;
            lock_expires_at: string;
            validationqueue: { value: number; label: string } | null;
            user: { value: number; label: string } | null;
            besc: { value: number; label: string } | null;
        }

        const formData = reactive<FormDataType>({
            status: null,
            priority: null,
            sla_due_at: "",
            started_at: "",
            completed_at: "",
            returned_at: "",
            last_action_at: "",
            lock_expires_at: "",
            validationqueue: null,
            user: null,
            besc: null,
        });
        const getValidationTask = async (id: string) => {
            try {
                const response = await ApiService.get(`/validationt/${id}`);
                const donnees = response.data.data;

                // Champs simples


                // Champs date
                formData.sla_due_at = formatDate(donnees.sla_due_at);
                formData.started_at = formatDate(donnees.started_at);
                formData.completed_at = formatDate(donnees.completed_at);
                formData.returned_at = formatDate(donnees.returned_at);
                formData.last_action_at = formatDate(donnees.last_action_at);
                formData.lock_expires_at = formatDate(donnees.lock_expires_at);

                // Status (statique)
                formData.status = statusOptions.find(opt => opt.value === donnees.status) || null;
                formData.priority = priorityOptions.find(opt => opt.value === donnees.priority) || null;
                // Validation Queue
                formData.validationqueue = donnees.validationqueue ? {
                    value: donnees.validationqueue.id,
                    label: donnees.validationqueue.name
                } : null;

                // User
                formData.user = donnees.user ? {
                    value: donnees.user.id,
                    label: `${donnees.user.nom} ${donnees.user.prenom}`
                } : null;

                // BESC
                formData.besc = donnees.besc ? {
                    value: donnees.besc.id,
                    label: donnees.besc.refbesc
                } : null;

            } catch (err: any) {
                error(err.response?.data?.message || "Erreur lors du chargement");
            }
        };

        const EditValidationTask = async () => {
            try {
                const payload = {
                    status: formData.status?.value,
                    priority: formData.priority?.value,
                    sla_due_at: formData.sla_due_at,
                    started_at: formData.started_at,
                    completed_at: formData.completed_at,
                    returned_at: formData.returned_at,
                    last_action_at: formData.last_action_at,
                    lock_expires_at: formData.lock_expires_at,
                    validationqueue_id: formData.validationqueue?.value,
                    user_id: formData.user?.value,
                    besc_id: formData.besc?.value,
                };
                console.log("Payload FINAL :", payload);

                await ApiService.put(`/validationt/${taskId}`, payload);
                success("Modification réussie !");
                router.push("/listevalidationtasks");
            } catch (err: any) {
                error(err.response?.data?.message || "Échec de la modification");
            }
        };
        onMounted(async () => {
            await fetchBesc();
            // await fetchUser();
            await getUsers();
            await fetchValidationQueue();
            await getValidationTask(taskId as string)
        })

        return {
            EditValidationTask,
            EditTaskSchema,
            formData,
            validationqueueOptions,
            userOptions,
            bescOptions,
            statusOptions,
            priorityOptions
        };
    },
});
</script>